import React, { useState } from 'react';

const Collapsible = ({children}) => {
    const [isExpanded,setIsExpanded] = useState(false)
    return (
        <>{children({ isExpanded, setIsExpanded })}</>
    );
};

export default Collapsible;